import { useState } from "react"
import config from "../../config"
import { useAppSelector } from "../../store/store"
import Modal from "../../components/Modal"
import ModalCard from "../../components/ModalCard"
import Button from "../../components/Button"
import { updateTeamLogo } from "../../services/team.services"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"

const UPDATE_TEAM_LOGO_PRICE = 0.40
const TeamLogo = () => {
    const token = useAppSelector(state => state.token)
    const team = useAppSelector(state => state.team)
    const player = useAppSelector(state => state.player)
    const isMember = player.teams?.find((member) => member.team_id === team.id)
    const navigate = useNavigate()


    const [requesting, setRequesting] = useState(false)
    const [logo, setLogo] = useState<File | null>(null)
    const [logoUrl, setLogoUrl] = useState<string>(`${config.API_URL}/teams/${team.id}/logo`)
    const [modalOpen, setModalOpen] = useState(false)

    const onChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
        const logo = event.target.files?.item(0)

        if (logo) {
            setLogo(logo)
            setLogoUrl(URL.createObjectURL(logo))
        }
    }

    const handleSubmit = () => {
        if (!logo) {
            toast.error("Selecciona una imagen")
            return
        }
        setRequesting(true)
        updateTeamLogo({ token: token || "", teamId: team.id as string, logo: logo as File })
            .then(() => {
                toast.success("Logo actualizado!")
                navigate(0)
            })
            .catch((error) => {
                toast.error(error.response.data.message)
            })
            .finally(() => setRequesting(false))
    }

    return (
        <>
            <img
                className="min-w-[150px] max-w-[150px] min-h-[150px] max-h-[150px] rounded-full cursor-pointer"
                src={`${config.API_URL}/teams/${team.id}/logo`}
                alt={`${team.name}_logo`}
                onClick={() => setModalOpen(true)}
            />

            {isMember?.admin && (
                <Modal modalOpen={modalOpen} set={setModalOpen}>
                    <ModalCard>
                        <div className="flex flex-col gap-5">
                            <p className="text-zinc-700 text-xl">Actualizar</p>
                            <label className="cursor-pointer self-center">
                                <img
                                    className="min-w-[150px] max-w-[150px] min-h-[150px] max-h-[150px] rounded-full cursor-pointer"
                                    src={logoUrl}
                                    alt={`${team.name}_logo`}
                                />
                                <input type="file" onChange={onChange} hidden />
                            </label>

                            <Button onClick={handleSubmit} spinner={requesting} disabled={requesting}>Actualizar (CT${UPDATE_TEAM_LOGO_PRICE.toFixed(2)})</Button>
                        </div>
                    </ModalCard>
                </Modal>
            )}

        </>
    )
}

export default TeamLogo